const KEYS = {
    KEY_CODE_TAB: 9,
    KEY_CODE_ENTER: 13,
    KEY_CODE_LEFT_ARROW: 37,
    KEY_CODE_UP_ARROW: 38,
    KEY_CODE_RIGHT_ARROW: 39,
    KEY_CODE_DOWN_ARROW: 40
};

export {
    KEYS
};